export enum ClinicProfessionalSubscriptionType {
  PUBLIC = 'PUBLIC',
  COMPANY = 'COMPANY',
}
